exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".thank-you-page-wrapper {\n  padding: 100px 0;\n}\n.tooltip-thank-you-page {\n  padding: 5px 20px;\n  width: 70%;\n  border-radius: 20px;\n  text-align: center;\n  position: relative;\n  margin: 0 auto;\n  margin-bottom: 20px;\n  margin-top: 25px;\n  width: fit-content;\n  font-size: 16px;\n  padding-top: 7px;\n}\n.tooltip-thank-you-page-edge {\n  position: absolute;\n  left: 50%;\n  top: -20px;\n  transform: translateX(-50%);\n  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\n  height: 20px;\n  width: 20px;\n}\n.thank-you-page-button {\n  padding: 15px 35px;\n  border-radius: 20px;\n  border: none;\n  font-size: 16px;\n}\n.thank-you-page-btn-container {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  margin-top: 40px;\n}\n.no-padding {\n  padding: 0px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/features/home/ThankyouTerminalPage.less
// module id = 1728
// module chunks = 0